<template>
  <div class="main">
    <div>
      <div class="new-notify">
        <!-- <trade-detail-form
          :trade_detail_form="trade_detail_form"
          v-if="trade_detail_form.flag"
        >
        </trade-detail-form> -->

        <NotificationTradeCard
          :trade_detail_form="trade_detail_form"
          v-if="trade_detail_form.flag"
        />
        <div class="d-flex notification-text-div">
          <p>Notifications</p>
          <v-spacer></v-spacer>
          <!-- <v-tooltip
            max-width="300"
            content-class="tooltip"
            color="#F7FAFF"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="mark-read-div"
                v-bind="attrs"
                v-on="on"
                @click="markAllRead"
              >
                <v-img :src="markRead" class="mark-read-img"></v-img>
              </div>
            </template>
            <span class="tooltip-text">Mark all as read</span>
          </v-tooltip> -->
          <v-btn text class="text-none" @click="markAllRead">
            <span>Mark all as read</span>
          </v-btn>
        </div>

        <div v-if="notificationLoading" class="d-flex flex-wrap flex-column">
          <v-skeleton-loader
            height="80"
            v-for="item in 6"
            :key="item.id"
            class="mt-5 prev-card"
            type="card-avatar, card,button, actions"
          ></v-skeleton-loader>
        </div>
        <div
          v-if="!notifications.length && !notificationLoading"
          class="justify-center mt-15 d-flex"
        >
          <h4>There are no notifications at the moment</h4>
        </div>
        <div v-if="!notificationLoading">
          <div
            @mouseover="saveId(i.id)"
            class="card mt-2"
            :class="i.read ? 'prev-card' : 'card'"
            v-for="i in notifications"
            :key="i.id"
          >
            <div
              @click="clickAction(i)"
              class="d-flex align-center notify-card"
            >
              <div class="d-flex">
                <div class="image-div">
                  <v-img
                    class="covesto-logo"
                    v-if="i.notification_type == 'version_update'"
                    :src="covesto_logo"
                  >
                  </v-img>
                  <v-img
                    v-if="
                      i.follower_image && i.notification_type == 'following you'
                    "
                    :src="getImg(i.follower_image)"
                    class="user-img"
                  ></v-img>
                  <v-img
                    :src="bellIcon"
                    v-if="
                      i.notification_type === 'following your trade' ||
                      i.notification_type === 'commented on' ||
                      i.notification_type === 'now active' ||
                      i.notification_type === 'now closed' ||
                      i.notification_type ===
                        'updated reasoning on their trade' ||
                      i.notification_type === 'posted a new trade' ||
                      i.notification_type === 'has been deleted' ||
                      i.notification_type === 'posted a new group trade' ||
                      i.notification_type === 'kyc_completed'
                    "
                  ></v-img>
                  <v-avatar
                    v-if="
                      !i.follower_image &&
                      i.notification_type == 'following you'
                    "
                    size="32"
                    class="user-img"
                    style="
                      height: 40px;
                      font-size: 14px;
                      background-color: lightblue;
                      object-fit: cover;
                      border-radius: 50%;
                    "
                  >
                    {{ i.follower_name | reduceToInitials }}
                  </v-avatar>
                </div>
                <div
                  class="pl-2 text-left"
                  v-if="
                    i.notification_type === 'following your trade' ||
                    i.notification_type === 'commented on' ||
                    i.notification_type === 'now active' ||
                    i.notification_type === 'now closed' ||
                    i.notification_type ===
                      'updated reasoning on their trade' ||
                    i.notification_type === 'posted a new trade' ||
                    i.notification_type === 'has been deleted' ||
                    i.notification_type === 'posted a new group trade' ||
                    i.notification_type == 'following you' ||
                    i.notification_type == 'version_update' ||
                    i.notification_type === 'kyc_completed'
                  "
                >
                  <div>
                    <span class="user-name">{{ i.notification_text }}</span>
                  </div>
                  <div>
                    <span class="post-time">{{ i.action_time }} ago</span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  i.notification_type === 'group_join_request' ||
                  i.notification_type === 'request_accepted' ||
                  i.notification_type === 'group_joined'
                "
                class="pl-2 text-left"
              >
                <div class="d-flex">
                  <div>
                    <v-img
                      v-if="i.follower_image"
                      :src="getImg(i.follower_image)"
                      class="user-img"
                    ></v-img>
                    <v-avatar
                      v-else
                      size="32"
                      class="user-img"
                      style="
                        height: 40px;
                        font-size: 14px;
                        background-color: lightblue;
                        object-fit: cover;
                        border-radius: 50%;
                      "
                    >
                      {{ i.follower_name | reduceToInitials }}
                    </v-avatar>
                  </div>
                  <div>
                    <div
                      v-if="i.notification_type === 'group_join_request'"
                      class="pl-2"
                    >
                      <span v-if="!i.read">
                        {{ i.follower_name }} requested to join your group
                        {{ i.group_name }}
                      </span>
                      <span v-else>
                        {{ i.follower_name }} added to group
                        {{ i.group_name }}
                      </span>
                      <span class="user-name">{{ i.notification_text }}</span>
                    </div>
                    <div
                      class="pl-2"
                      v-else-if="i.notification_type === 'request_accepted'"
                    >
                      {{ i.follower_name }} you are added to {{ i.group_name }}
                    </div>
                    <div
                      v-else-if="i.notification_type === 'group_joined'"
                      class="pl-2"
                    >
                      {{ i.follower_name }} joined {{ i.group_name }}
                    </div>
                    <div class="d-flex pl-2 flex-column text-left">
                      <span class="post-time">{{ i.action_time }} ago</span>
                    </div>
                    <div class="pl-2 pt-2" v-if="i.group_request_status">
                      <v-btn
                        class="text-none font-weight-bold"
                        dark
                        color="#2D8CFF"
                        elevation="0"
                        @click="member_action(i, 'accept')"
                        v-if="i.group_request_status"
                      >
                        accept
                      </v-btn>
                      <v-btn
                        class="text-none font-weight-bold ml-1"
                        text
                        style="border: 1px solid #2d8cff"
                        v-if="i.group_request_status"
                        @click="member_action(i, 'delete')"
                      >
                        <span style="color: #2d8cff">cancel</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-4">
        <v-btn
          class="btnClass text-capitalize"
          @click="showMore"
          v-if="total_page > 1"
          :loading="moreNotificationLoader"
          :width="$vuetify.breakpoint.xsOnly ? '100%' : '60%'"
          color="#ffff"
        >
          <span>show more</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
import { mapGetters } from "vuex";
// import TradeDetailForm from "../components/Trade/TradeDetailForm.vue";
import NotificationTradeCard from "../components/Trade/NotificationTradeCard.vue";

export default {
  name: "Notification",
  components: {
    // "trade-detail-form": TradeDetailForm,
    NotificationTradeCard,
  },
  metaInfo: {
    title: "Notifications",
  },
  data: () => ({
    notifications: [],
    readNotifications: [],
    unreadNotifications: [],
    notificationLoading: false,
    showIcon: false,
    notId: null,
    bellIcon: require("../assets/images/bellIcon.svg"),
    markRead: require("../assets/images/mark_all_read_1.svg"),
    covesto_logo: require("../../public/covesto_logo_c.png"),
    trade_detail_form: {
      flag: false,
      id: null,
    },
    itemPerPage: 10,
    total_page: 1,
    moreNotificationLoader: false,
  }),
  computed: {},
  watch: {
    itemPerPage() {
      this.getNotifications(true);
    },
  },
  methods: {
    ...mapGetters("Auth", ["notificationCount"]),
    saveId(id) {
      this.notId = id;
    },
    showMore() {
      this.itemPerPage = this.itemPerPage + 10;
    },
    getImg(link) {
      console.log(window.location.href, "link");
      // return "https://api.covesto.in" + link;
      return link;
    },
    member_action(item, action) {
      const successHandler = () => {
        this.getNotifications(false);
        this.markAsRead(item.id);
      };
      const failureHandler = () => {};
      let formData = {};
      formData["group"] = item.group;
      formData["member"] = item.user_id;
      formData["membership_type"] = "member";
      if (action === "accept") {
        Axios.request_PATCH(
          "/api/join-leave/",
          formData,
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      } else {
        Axios.request_DELETE(
          "/api/join-leave/",
          formData,
          {},
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      }
    },
    markAsRead(id) {
      const successHandler = (res) => {
        console.log(res.data);
        this.getNotifications(false);
      };
      const errorHandler = (err) => {
        console.error(err);
      };
      Axios.request_POST(
        `api/read-notification/${id}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    markAllRead() {
      const user_id = localStorage.getItem("user_id");
      if (!this.unreadNotifications.length) return;
      const successHandler = (res) => {
        console.log(res.data);
        this.getNotifications(false);
        this.$logEvent("notification_cleared");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_notification_cleared");
        }
      };
      const errorHandler = (err) => {
        console.error(err);
      };
      Axios.request_POST(
        `api/mark-all-read/${user_id}/`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    clickAction(i) {
      if (i.notification_type === "following you") {
        console.log("this profile", i);
        this.gotoProfile(i);
      } else if (
        i.notification_type === "following your trade" ||
        i.notification_type === "commented on" ||
        i.notification_type === "now active" ||
        i.notification_type === "now closed" ||
        i.notification_type === "updated reasoning on their trade" ||
        i.notification_type === "posted a new trade" ||
        i.notification_type === "has been deleted"
      ) {
        this.openTrade(i);
      } else if (i.notification_type === "group_join_request") {
        return "";
      } else {
        this.goToHome(i);
        this.markAsRead(i.id);
      }
    },
    gotoProfile(i) {
      console.log("inside go to progile", i.id, i.follower, i.follower_name);
      this.$router.push({
        name: "OthersProfilePage",
        params: { id: i.user_id, name: i.follower_name },
      });
      this.queryData = null;
      this.search_list = [];
      this.markAsRead(i.id);
    },
    goToHome() {
      this.$router.push({
        name: "HomePage",
        params: { id: localStorage.getItem("user_id") },
      });
    },
    openTrade(i) {
      console.log(i, "hey");
      this.trade_detail_form.id = i.trade;
      this.trade_detail_form.flag = true;
      this.markAsRead(i.id);
    },
    getNotifications(btnState) {
      if (!btnState) {
        this.notificationLoading = true;
      } else {
        this.moreNotificationLoader = true;
      }
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        console.log(res.data);
        this.notifications = res.data.result;
        this.total_page = res.data.total_page;
        this.readNotifications = res.data.result.filter(
          (item) => item.read === true
        );
        this.unreadNotifications = res.data.result.filter(
          (item) => item.read === false
        );
        this.$store.state.Auth.readCount = res.data.total_unread_count;
        console.log(this.readNotifications, this.unreadNotifications, "log");
        setTimeout(() => {
          this.notificationLoading = false;
          this.moreNotificationLoader = false;
        }, 500);
      };
      const errorHandler = (err) => {
        console.error(err);
        setTimeout(() => {
          this.notificationLoading = false;
          this.moreNotificationLoader = false;
        }, 500);
      };
      let formData = {};
      formData["detail_count"] = this.itemPerPage;
      Axios.request_GET(
        `api/my-notifications/${user_id}`,
        formData,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },
  created() {
    this.eventBus.$on("update-notifications", () => {
      this.getNotifications();
    });
  },
  mounted() {
    this.getNotifications();
    console.log(this.notificationCount());
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 100vh;
  padding: 35px;
  background: #fafafa;
}
.prev-card,
.card {
  width: 60%;
  padding: 10px;
  align-items: center;
  background: #fff;
  text-align: center;
  box-shadow: 0px 2px 8px rgba(49, 93, 146, 0.24);
  border-radius: 8px;
}
.prev-card {
  opacity: 0.5;
}
.notification-text-div {
  width: 60%;
}
.tooltip {
  background: #f7faff;
  opacity: 1 !important;
  text-align: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px !important;
}
.tooltip-text {
  color: #111111 !important;
}
.close-icon {
  background-color: #ccdef8;
  // border-radius: 20%;
  height: 15px;
  width: 17px;
}
.notify-card {
  cursor: pointer;
}

.mark-read-img {
  object-fit: cover;
  height: 100%;
  width: 100%px !important;
}
.mark-read-div {
  width: 30px;
  height: 20px;
  cursor: pointer;
}
.user-img {
  border-radius: 50%;
  object-fit: cover;
  height: 38px;
  width: 38px !important;
}
p {
  color: #333333;
  font-weight: 800;
  font-size: 16px;
}
.covesto-logo {
  border-radius: 50%;
  object-fit: cover;
  height: 38px !important;
  width: 38px !important;
  background-color: #ccdef8;
}
@media all and (max-width: 600px) {
  .card,
  .prev-card {
    width: 100%;
  }
  .main {
    padding: 20px;
    margin-bottom: 60px;
  }
  .notification-text-div {
    width: 100%;
  }
}
</style>
<style scoped>
.btnClass >>> span {
  color: #2d8cff;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
}
</style>
